export function formatPrice(amount) {
  return `${amount.toLocaleString('fr-FR')} FCFA`;
}
